import React from 'react';
import config from "../constants/config";
import {useTranslation} from "react-i18next";
import useFetchTheatron from "../hooks/useFetchTheatron";
import useTiming from "../hooks/useTiming";

const Footer = ({ children }) => {
  const theatron = useFetchTheatron();
  const {t} = useTranslation('global');
  const timing = useTiming();

  return (
      <footer id="footer" className="flex flex-col items-center mt-auto space-y-5">
        <div className="w-full">
          {children}
        </div>
        <div className="pt-5 border-t border-white border-opacity-20 w-full">
          <a
            href={`/${timing.id}/`}
            className={`logo mb-2 ${timing.venue.type == 'vod' ? 'revive':''}`}
            //target="_blank"
            style={{
            backgroundImage: `url(${timing?.venue?.logo || theatron.data?.logo})`
          }}
          >{theatron.data?.name}</a>
          <p className="text-gray-400 text-xs">{t('copyright', {app: theatron.data?.name, year:  (new Date).getFullYear()})}</p>
        </div>
      </footer>
  );
};

export default Footer;
